/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Pc_Common_ReleasedInputs */

const en_pc_common_released = /** @type {(inputs: Pc_Common_ReleasedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`released ${i?.date}`)
};

const zh_pc_common_released = /** @type {(inputs: Pc_Common_ReleasedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`发布于 ${i?.date}`)
};

/**
* | output |
* | --- |
* | "released {date}" |
*
* @param {Pc_Common_ReleasedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_common_released = /** @type {((inputs: Pc_Common_ReleasedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Common_ReleasedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_common_released(inputs)
	return zh_pc_common_released(inputs)
});
export { pc_common_released as "pc.common.released" }